import dayjs from 'dayjs';
import { I18n } from 'react-redux-i18n-lite';
import { DISCUSSION_TABS_CONSTANTS } from '../../../const';

const dayBucketKey = date => dayjs(date).format('YYYY-MM-DD');

const formatFutureLabel = date => {
  const daysUntilStart = dayjs(date).startOf('day').diff(dayjs().startOf('day'), 'day');

  if (daysUntilStart <= 0) {
    return I18n.t('discussions.grouping.startsToday');
  }
  if (daysUntilStart === 1) {
    return I18n.t('discussions.grouping.startsTomorrow');
  }
  return I18n.t('discussions.grouping.startsInDays', { days: daysUntilStart });
};

const formatPastOrPresentLabel = date => {
  if (dayjs(date).isSame(dayjs(), 'week')) {
    return I18n.t('discussions.grouping.thisWeek');
  }
  return dayjs(date).format('D [de] MMMM');
};

export const groupDiscussionsByDay = (discussions = [], tabKey) => {
  const sortDirection = tabKey === DISCUSSION_TABS_CONSTANTS.FUTURE.key ? 1 : -1;
  const sortedDiscussions = [...discussions].sort(
    (a, b) => sortDirection * (dayjs(a.startDate).valueOf() - dayjs(b.startDate).valueOf())
  );

  const buckets = {};

  sortedDiscussions.forEach(discussion => {
    const key = dayBucketKey(discussion.startDate);
    if (!buckets[key]) {
      buckets[key] = { date: discussion.startDate, discussions: [] };
    }
    buckets[key].discussions.push(discussion);
  });

  return Object.values(buckets).map(bucket => ({
    label:
      tabKey === DISCUSSION_TABS_CONSTANTS.FUTURE.key
        ? formatFutureLabel(bucket.date)
        : formatPastOrPresentLabel(bucket.date),
    discussions: bucket.discussions
  }));
};
